import React, { useContext } from 'react';
import { Text, Layout, LayoutItem, Card } from '@oneaudi/unified-web-components';
import { ContentContext } from '../context/ContentContext';

export const ModelBand = () => {
  const context = useContext(ContentContext);
  const { personalizedResults } = context;

  // Return in node
  if (typeof window === 'undefined') {
    return null;
  }
  // Hide this component if needed when not on localhost
  const debugPCT = window.localStorage.getItem('debugPCT');
  if (window.location.href.includes('localhost') === false && debugPCT !== 'yes') {
    return null;
  }

  let mbbContent = [];
  if (personalizedResults) {
    const recommendationsKeys = Object.keys(personalizedResults);
    if (recommendationsKeys.length) {
      mbbContent = recommendationsKeys.map((modelName, i) => {
        return (
          <LayoutItem key={`${i}-${modelName}`}>
            <Card>
              <Text> {modelName} </Text>
            </Card>
          </LayoutItem>
        );
      });
    }
  }
  return (
    <Layout
      align="center"
      as="div"
      className="className"
      columnGap="24px"
      direction="row"
      rowGap="12px"
      padding={['50px', '25px']}
    >
      {mbbContent}
    </Layout>
  );
};
